import {Axios} from '../../../setup'

interface DownloadInterface {
  api: string
  id: string
  fileName: string
  fileExtension: string
  params?: {}
}

export function FileDownload({data, fileName, fileExtension}: {data: any, fileName: string, fileExtension: string}) {

  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.${fileExtension}`);
  document.body.appendChild(link);
  link.click();
}


export const Download = async ({api, id, fileName, fileExtension, params}: DownloadInterface) => {

  const endpoint = `${api}/${id}`

  try {
    const {status, data} = await Axios.get<Blob>(endpoint, {params, responseType: 'blob'})
    if (status === 200) FileDownload({data, fileName, fileExtension})
  } catch (e) {
    console.error('Error exporting to Excel:', e)
  }
}